import { render } from "./ShareIcon.vue?vue&type=template&id=474771a8"
const script = {}
script.render = render

export default script